import { FAQItem } from '../components/FAQItem';
import { SectionWrapper } from '../components/SectionWrapper';

import styles from './FAQSection.module.css';

const faqs = [
  {
    answer:
      "Yes. Create an account, fill in a short profile, build a course. No charge. Students are $25 per semester for full-course access. There's nothing to upgrade and no credit card required to try.",
    question: 'Is it actually free for instructors?',
  },
  {
    answer:
      'You do. Whether you or your institution holds the rights depends on your local IP policy, not ours. Kudu does not own or claim the copyright. If you stop using us, you take your content with you.',
    question: 'Who owns the content I create?',
  },
  {
    answer:
      "Most don't. Most institutions mandate the textbook, not the platform you teach with. Kudu uses OpenStax content that aligns with your designated textbook, and can run alongside an existing publisher.",
    question: 'What if my institution requires me to use Pearson / Cengage?',
  },
  {
    answer:
      'Price and simplicity — and the AI. One flat fee for everything: the textbook, the homework, the clickers, and the AI tools in one platform at a fraction of the cost. We replace the stack, not add to it.',
    question: 'How is this different from Top Hat or WebAssign?',
  },
  {
    answer:
      "No. The AI is scoped to your course content and trained to guide students through problems. It will not just hand over the answer. UCLA's CEILS published independent research showing it actually improves learning outcomes.",
    question: 'Does the AI just give students answers?',
  },
  {
    answer:
      'Completely freely. Every section, every question, every video can be edited. Add your own content. Reorder chapters. Swap in your assignments. Or leave it — the pre-built version is ready to teach as-is.',
    question: 'What if I want to customize the pre-built course?',
  },
] as const;

export function FAQSection() {
  return (
    <SectionWrapper background="soft" data-testid="faculty-section-faq">
      <div className={styles.section}>
        <div className={styles.header}>
          <p className={styles.eyebrow}>FREQUENTLY ASKED</p>
          <h2 className={styles.title}>The questions faculty ask first.</h2>
        </div>

        <div className={styles.grid}>
          {faqs.map((faq) => (
            <FAQItem key={faq.question} {...faq} />
          ))}
        </div>

        <div className={styles.footer}>
          <p>Question we didn&apos;t answer here?</p>
          <a href="mailto:support@kudu.com">support@kudu.com</a>
        </div>
      </div>
    </SectionWrapper>
  );
}
